import React, { useContext } from "react";
import { Controller } from "react-hook-form";
import FormContext from "../../context/formContext";
import "./index.scss";

/**
 * @desc Custom toggle. Customizable:
 *  - input props
 *  - label props
 *  - error props
 *  - ignore error
 *  - checkbox feature
 *  - controlled boolean
 *  - pulls control from Form context
 */
export const Toggle = ({
  inputProps = {},
  labelProps = {},
  errorProps = {},
  fieldName,
  ignoreError = false,
  controlled = true,
}) => {
  // CONSTANTS ----------------------------------------------------------------

  const { control = {} } = useContext(FormContext);
  const isCheckbox = inputProps.type === "checkbox";

  // METHODS ------------------------------------------------------------------

  const renderError = ({ invalid, error }) => {
    if (!invalid || ignoreError) return;
    const errorIconProps = {
      src: "https://funko.com/on/demandware.static/Sites-FunkoUS-Site/-/default/dwe062a1ec/images/svg/error.svg",
      className: "svg-symbol error error-icon",
    };
    return (
      <div className="invalid-feedback" {...errorProps}>
        <img alt={"error-icon"} {...errorIconProps} />
        <span role="alert">{error.message}</span>
      </div>
    );
  };

  // COMPONENT ----------------------------------------------------------------

  if (!controlled) {
    const inputUncontrolledProps = {
      ...inputProps,
      value: true,
      type: "checkbox",
      className: `${inputProps.className} ${
        isCheckbox ? "custom-control-input" : ""
      }`,
    };
    return (
      <div
        className={`form-group ${inputProps.required ? "required" : ""} ${
          isCheckbox ? "custom-control custom-checkbox" : ""
        }`}
      >
        <span className="label-text">{labelProps.children}</span>
        <label
          className={`switch ${isCheckbox ? "custom" : "form"}-control-label`}
          {...labelProps}
        >
          <input {...inputUncontrolledProps} />
          <span className="slider"></span>
        </label>
      </div>
    );
  }

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, onBlur, value }, fieldState }) => {
        const invalid = fieldState.invalid;
        const inputControllerProps = {
          ...inputProps,
          onChange,
          onBlur,
          value: !!value,
          checked: !!value,
          type: "checkbox",
          className: `${inputProps.className} ${
            invalid && !ignoreError ? "is-invalid" : ""
          } ${isCheckbox ? "custom-control-input" : ""}`,
        };

        if (isCheckbox) {
          inputControllerProps.checked = !!value;
        }

        return (
          <div
            className={`toggle form-group ${
              inputProps.required ? "required" : ""
            } ${isCheckbox ? "custom-control custom-checkbox" : ""}`}
          >
            <span className="label-text">{labelProps.children}</span>
            <label
              className={`${isCheckbox ? "custom" : "form"}-control-label`}
              {...labelProps}
            >
              <input {...inputControllerProps} />
              <span className="slider round"></span>
              {renderError(fieldState)}
            </label>
          </div>
        );
      }}
    />
  );
};
